module.exports = __webpack_public_path__ + "img/swiggy.6dc56afc.png";